import { canDownloadCvTarget } from '../lib/cv-download-permission';
import { readGrantTargetId } from '../lib/cv-target-route';
import { useReceivedCvAccessGrants } from './useCvCollaborationApi';

/**
 * Whether the Download controls of a share surface may show for `target`
 * (see `canDownloadCvTarget`). The received-grants query only runs for a
 * delegated target; the user's own CVs answer `true` without a request.
 */
export function useCanDownloadCvTarget(target: string | null | undefined) {
  const isDelegated = Boolean(target && readGrantTargetId(target));
  const { data } = useReceivedCvAccessGrants({ enabled: isDelegated });
  return canDownloadCvTarget(target, data);
}
